"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isCustomerGroupname = exports.getTechnicianGroupnames = exports.getSurveyLoaderGroupnames = exports.getSupervisorGroupnames = exports.getProjectManagerGroupnames = exports.getCustomerAdminsGroupnames = exports.getAegionProjectManagerGroupNames = exports.getAegionDataProcessorGroupnames = exports["default"] = exports.customerNameToCustomerGroupname = exports.customerGroupnameToCustomerName = exports.TESTS = void 0;

var _mappings = require("./mappings");

var KEY_TECHNICIAN = 'technician';
var KEY_PROJECT_MANAGER = 'projectManager';
var KEY_SUPERVISOR = 'supervisor';
var KEY_CUSTOMER_ADMINS = 'customeradmins';
var KEY_AEGION_PROJECT_MANAGER = 'aegionProjectManager';
var KEY_AEGION_DATA_PROCESSOR = 'aegionDataProcessor';
var KEY_SURVEY_LOADER = 'surveyLoader';

var getMappingsAndKeys = function getMappingsAndKeys(allMappings, customer) {
  var mappings = allMappings[customer] || allMappings.DEFAULT;
  var keys = Object.keys(mappings);
  return {
    mappings: mappings,
    keys: keys // not currently in use

  };
};

var isCustomerGroupname = function isCustomerGroupname() {
  var customerGroupname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return /^Customer:/.test(customerGroupname);
};

exports.isCustomerGroupname = isCustomerGroupname;

var customerNameToCustomerGroupname = function customerNameToCustomerGroupname() {
  var customerName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return "Customer:".concat(customerName.trim().split(' ').filter(function (v) {
    return !!v;
  }).join('_'));
};

exports.customerNameToCustomerGroupname = customerNameToCustomerGroupname;

var customerGroupnameToCustomerName = function customerGroupnameToCustomerName() {
  var customerGroupname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return customerGroupname.replace(/^Customer:/, '').split('_').filter(function (v) {
    return v;
  }).join(' ');
};

exports.customerGroupnameToCustomerName = customerGroupnameToCustomerName;

var _getCustomerAdminsGroupnames = function _getCustomerAdminsGroupnames(allMappings, customer) {
  var _getMappingsAndKeys = getMappingsAndKeys(allMappings, customer),
      mappings = _getMappingsAndKeys.mappings;

  return mappings[KEY_CUSTOMER_ADMINS];
};

var _getTechnicianGroupnames = function _getTechnicianGroupnames(allMappings, customer) {
  var _getMappingsAndKeys2 = getMappingsAndKeys(allMappings, customer),
      mappings = _getMappingsAndKeys2.mappings;

  return mappings[KEY_TECHNICIAN];
};

var _getProjectManagerGroupnames = function _getProjectManagerGroupnames(allMappings, customer) {
  var _getMappingsAndKeys3 = getMappingsAndKeys(allMappings, customer),
      mappings = _getMappingsAndKeys3.mappings;

  return mappings[KEY_PROJECT_MANAGER];
};

var _getSupervisorGroupnames = function _getSupervisorGroupnames(allMappings, customer) {
  var _getMappingsAndKeys4 = getMappingsAndKeys(allMappings, customer),
      mappings = _getMappingsAndKeys4.mappings;

  return mappings[KEY_SUPERVISOR];
};

var _getAegionProjectManagerGroupNames = function _getAegionProjectManagerGroupNames(allMappings, customer) {
  var _getMappingsAndKeys5 = getMappingsAndKeys(allMappings, customer),
      mappings = _getMappingsAndKeys5.mappings;

  return mappings[KEY_AEGION_PROJECT_MANAGER];
};

var _getAegionDataProcessorGroupnames = function _getAegionDataProcessorGroupnames(allMappings, customer) {
  var _getMappingsAndKeys6 = getMappingsAndKeys(allMappings, customer),
      mappings = _getMappingsAndKeys6.mappings;

  return mappings[KEY_AEGION_DATA_PROCESSOR];
};

var _getSurveyLoaderGroupnames = function _getSurveyLoaderGroupnames(allMappings, customer) {
  var _getMappingsAndKeys7 = getMappingsAndKeys(allMappings, customer),
      mappings = _getMappingsAndKeys7.mappings;

  return mappings[KEY_SURVEY_LOADER];
};

var createGroupnameMappingGetters = function createGroupnameMappingGetters() {
  var allMappings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _mappings.MAPPINGS;
  return {
    getCustomerAdminsGroupnames: function getCustomerAdminsGroupnames(customer) {
      return _getCustomerAdminsGroupnames(allMappings, customer);
    },
    getTechnicianGroupnames: function getTechnicianGroupnames(customer) {
      return _getTechnicianGroupnames(allMappings, customer);
    },
    getProjectManagerGroupnames: function getProjectManagerGroupnames(customer) {
      return _getProjectManagerGroupnames(allMappings, customer);
    },
    getSupervisorGroupnames: function getSupervisorGroupnames(customer) {
      return _getSupervisorGroupnames(allMappings, customer);
    },
    getAegionProjectManagerGroupNames: function getAegionProjectManagerGroupNames(customer) {
      return _getAegionProjectManagerGroupNames(allMappings, customer);
    },
    getAegionDataProcessorGroupnames: function getAegionDataProcessorGroupnames(customer) {
      return _getAegionDataProcessorGroupnames(allMappings, customer);
    },
    getSurveyLoaderGroupnames: function getSurveyLoaderGroupnames(customer) {
      return _getSurveyLoaderGroupnames(allMappings, customer);
    }
  };
};

var _createGroupnameMappi = createGroupnameMappingGetters(),
    getCustomerAdminsGroupnames = _createGroupnameMappi.getCustomerAdminsGroupnames,
    getTechnicianGroupnames = _createGroupnameMappi.getTechnicianGroupnames,
    getProjectManagerGroupnames = _createGroupnameMappi.getProjectManagerGroupnames,
    getSupervisorGroupnames = _createGroupnameMappi.getSupervisorGroupnames,
    getAegionProjectManagerGroupNames = _createGroupnameMappi.getAegionProjectManagerGroupNames,
    getAegionDataProcessorGroupnames = _createGroupnameMappi.getAegionDataProcessorGroupnames,
    getSurveyLoaderGroupnames = _createGroupnameMappi.getSurveyLoaderGroupnames;

exports.getSurveyLoaderGroupnames = getSurveyLoaderGroupnames;
exports.getAegionDataProcessorGroupnames = getAegionDataProcessorGroupnames;
exports.getAegionProjectManagerGroupNames = getAegionProjectManagerGroupNames;
exports.getSupervisorGroupnames = getSupervisorGroupnames;
exports.getProjectManagerGroupnames = getProjectManagerGroupnames;
exports.getTechnicianGroupnames = getTechnicianGroupnames;
exports.getCustomerAdminsGroupnames = getCustomerAdminsGroupnames;
var TESTS = {
  isCustomerGroupname: isCustomerGroupname,
  customerNameToCustomerGroupname: customerNameToCustomerGroupname,
  customerGroupnameToCustomerName: customerGroupnameToCustomerName,
  createGroupnameMappingGetters: createGroupnameMappingGetters
};
exports.TESTS = TESTS;
var _default = {
  isCustomerGroupname: isCustomerGroupname,
  customerNameToCustomerGroupname: customerNameToCustomerGroupname,
  customerGroupnameToCustomerName: customerGroupnameToCustomerName,
  getCustomerAdminsGroupnames: getCustomerAdminsGroupnames,
  getTechnicianGroupnames: getTechnicianGroupnames,
  getProjectManagerGroupnames: getProjectManagerGroupnames,
  getSupervisorGroupnames: getSupervisorGroupnames,
  getAegionProjectManagerGroupNames: getAegionProjectManagerGroupNames,
  getAegionDataProcessorGroupnames: getAegionDataProcessorGroupnames,
  getSurveyLoaderGroupnames: getSurveyLoaderGroupnames,
  TESTS: TESTS
};
exports["default"] = _default;